const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelfieImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 286,
    height: 360,
    viewBox: "0 0 286 360",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 143,
    cy: 180,
    rx: 142.5,
    ry: 180,
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.728 314.574C116.024 308.338 107.139 304.11 90.6446 290.641C89.3862 289.73 87.8332 288.123 86.0529 285.855C79.0444 276.926 65.9443 257.753 55.9808 230.468C40.9341 231.808 38.6489 201.065 38.6489 201.065C38.6489 201.065 34.4881 176.613 41.2166 176.449C46.436 175.158 49.1253 175.813 53.4132 179.868V162.773C52.3508 143.419 50.3315 133.685 55.9808 112.857C61.9491 89.8694 84.3037 67.7114 86.0529 69.0947C85.34 67.474 110.984 54.3175 131.728 52C152.526 52.2719 163.076 56.0666 183.891 63.6662C197.472 72.613 203.036 78.8953 215.205 93.7528C223.358 109.14 224.806 116.276 227.374 133.371C229.942 150.465 226.697 166.97 226.732 179.868C234.441 174.684 241.321 175.585 248.623 185.338C248.512 198.914 243.626 205.874 239.636 219.528C234.685 232.555 220.37 231.855 219.029 232.52C217.688 233.184 210.713 261.481 197.205 281.752C193.162 287.818 189 293.709 185.007 298.847C166.768 311.75 156.956 319.32 131.728 314.574Z",
    stroke: "#D5D5D5",
    style: {
      stroke: "#D5D5D5",
      stroke: "color(display-p3 0.8353 0.8353 0.8353)",
      strokeOpacity: 1
    },
    strokeWidth: 4,
    strokeDasharray: "3 3"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfieImg);
export default __webpack_public_path__ + "static/media/selfieImg.a4b988b8c2b91bc8183a66cbcdea4b53.svg";
export { ForwardRef as ReactComponent };